import React from 'react';
import styled from 'styled-components';
import { display, grid } from 'styled-system';
const Component = styled.div `
  display: grid;

  ${display};
  ${grid};
`;
export const Grid = ({ htmlAttrs = {}, ...rest }) => (React.createElement(Component, { ...htmlAttrs, ...rest }));
Grid.defaultProps = {
    gridGap: 'x8',
};
//# sourceMappingURL=index.js.map